import { ErrorPage } from '@/components/pages/Error'
import { useMe } from '@/hooks/features/user'

import { WithRoleUploadOrderProps } from './type'

/**
 * 「仕入情報の表示権限」があるユーザーのみアクセス許可
 *
 * ※ 以前は「EC注文取込結果」も仕入情報の一部だったが、「注文取込」と同じ扱いに変更になった
 *
 * TODO:仕入情報はこちらの権限で利用制限する
 */
export const withRoleUploadOrder = (
  PageComponent: WithRoleUploadOrderProps
) => {
  return function RoleUploadOrderPage(props: any) {
    const { data, isSuccess } = useMe({})

    if (!isSuccess) {
      return null
    }

    // No permission to view purchase (uploadOrder) info
    if (!('uploadOrder' in data) || !data.uploadOrder) {
      return <ErrorPage statusCode={403} />
    }

    return <PageComponent {...props} />
  }
}
